module.exports = __webpack_public_path__ + "static/media/ini5-270w.0c782aeb.jpg";